import { DeviceConfigurationResponse } from './types';

type UpdateSection = DeviceConfigurationResponse['params']['UpdateSection'];

const SKIPPABLE_INTERVAL_50_SEC = 50;

export function processUpdateSection(updateSection: NonNullable<UpdateSection>) {
  const { appUpdate, dialog_language_code, updateTypePerBrands, skippable_interval } = updateSection;

  const { Blocked, Forced, Skip } = updateTypePerBrands ?? {};
  const isValidSkippableInterval = skippable_interval && Number.isInteger(skippable_interval) && skippable_interval > 0;
  const skippableInterval = isValidSkippableInterval ? skippable_interval : SKIPPABLE_INTERVAL_50_SEC;

  return {
    enabled: Boolean(appUpdate),
    languageCode: dialog_language_code,
    skippableInterval: skippableInterval * 1000,
    brands: {
      blocked: new Set(Blocked && Array.isArray(Blocked) ? Blocked : []),
      forced: new Set(Forced && Array.isArray(Forced) ? Forced : []),
      skippable: new Set(Skip && Array.isArray(Skip) ? Skip : []),
    },
  };
}
